module.exports = __webpack_public_path__ + "media/images/front/treatment_support/icon_trend_none-854f77faa214769b7357eb7f2b9dbad0.svg";